import { BusinessUnit, BusinessUnitResource } from '@/models'

import axios, { withToken } from './axios'

/**
 * Gets all BusinessUnits in a Provider.
 *
 * @param token Valid authentication Token.
 * @param providerId Provider whose BusinessUnits will be fetched.
 */
export async function fetchBusinessUnitList (
  token: string,
  providerId: number
): Promise<BusinessUnit[]> {
  const response = await axios.get<BusinessUnitResource[]>(
    `/api/providers/${providerId}/locations`,
    withToken(token)
  )

  return response.data.map((resource) => ({
    id: resource.id,
    name: resource.name,
    isActive: resource.active // Renaming
  }))
}
